<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <div class="card mt-4">
          <div class="card-header">
            <h3>Legg til Stevne Administrator</h3>
          </div>
          <div class="card-body">
            <form @submit.prevent="addAdministrator">
              <div class="form-group">
                <label for="username">Nummer (10 siffer)</label>
                <input type="text" class="form-control" id="username" v-model="username" pattern="\d{10}" title="Vennligst skriv inn 10 siffer" required>
              </div>
              <button type="submit" class="btn btn-primary">Legg til Administrator</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RoleDataService from "../services/RoleDataService";

export default {
  data() {
    return {
      username: '', // Initialize username data property
      competition_id: 0
    };
  },
  methods: {
    addAdministrator() {
      // Check if username is valid (10 digits)
      if (/^\d{10}$/.test(this.username)) {
        // Implement your logic to add administrator with this.username
        // Example: Call a method or API to add the administrator
        console.log('Adding administrator with username:', this.username);
        var data = {
          number: this.username,
          competition_id: this.competition_id
        };
        RoleDataService.create(data)
        .then(response => {
          console.log(response);
          // After adding administrator, you can navigate user to another page or perform any other action
        })
        .catch(e => {
          console.log(e);
        });

      } else {
        // If username is not valid, you can show an error message or handle it accordingly
        alert('Vennligst skriv inn et gyldig nummer bestående av 10 siffer.');
      }
    }
  },
  mounted() {
    this.competition_id = this.$route.params.competition_id;
  }
};
</script>
